/**
 * The /shani-transit/ "find your Moon sign" check: its anchor, analytics
 * placement and slot floor. The page's picker answers "where is Shani from my
 * Moon sign?" once a reader knows their Chandra rashi; this check settles it
 * from their birth details (the /rashi/<sign>/ check's engine call and
 * verdict, reused) and selects it in the picker, so the reading stays on this
 * page instead of the old outbound /rashi-calculator/ link (2026-10-20).
 */

/** The section's id, which the picker's empty panel links to. */
export const SHANI_MOON_CHECK_ANCHOR = "find-your-moon-sign";

/** free_tool_started and calculator_used placement for this page's check. */
export const SHANI_MOON_CHECK_PLACEMENT = "shani_transit_moon_check";

/**
 * The slot floor, from the server HTML: the tallest measured state, which
 * every state fills (ShaniMoonCheckLazy has the numbers).
 */
export const SHANI_MOON_CHECK_RESERVE = "min-h-[600px] sm:min-h-[500px]";
